import { render } from "./DefaultDemoCard.vue?vue&type=template&id=f89b0176&scoped=true"
import script from "./DefaultDemoCard.vue?vue&type=script&lang=js"
export * from "./DefaultDemoCard.vue?vue&type=script&lang=js"

import "./DefaultDemoCard.vue?vue&type=style&index=0&id=f89b0176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89b0176"]])

export default __exports__